import InsureProcessVehicleOwnerInfo from './InsureProcessVehicleOwnerInfo';
export default InsureProcessVehicleOwnerInfo;
